import { Popup } from '../../../ui/popup/popup';
import React, { useCallback, useEffect, useState } from 'react';
import Preloader from '../../../ui/svg/common/preloader';
import { addToCartPopup } from '../data/data-service';
import { useAppDispatch, rootActions, useAppSelector } from '../data/store';
import TopPanel from './top-panel';
import AddedCartItem from './added-cart-item';
import YouMayAlsoLike from './you-may-also-like';
import { tiktokAddToCartPopup } from '../../../domain/marketing/tiktok-provider';
import { facebookAddToCartPopup } from '../../../domain/facebook/facebook-marketing-provider';

interface IAddToCartPopup {
    productId: number;
}

export const addToCartPopupGaAction = 'AddToCartPopup';

const AddToCartPopup = ({ productId }: IAddToCartPopup) => {

    const dispatch = useAppDispatch();
    const cartData = useAppSelector(store => store.root.cartData);

    const [isOpened, setIsOpened] = useState(true);
    const [loading, setLoading] = useState(true);

    const addProductHandler = useCallback(async (productId: number) => {
        setLoading(true);
        const response = await addToCartPopup(productId);
        setLoading(false);

        if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData) return;

        dispatch(
            rootActions.setCartData(response.data.relatedData?.cartData ?? null),
        );

        dispatch(
            rootActions.main({
                addedCartItem: response.data.relatedData?.addedCartItem ?? null,
                addedCartItemAdditionalData: response.data.relatedData?.addedCartItemAdditionalData ?? null,
            })
        );

        // Handle marketing --------------------
        const addedCartItem = response.data.relatedData?.addedCartItem ?? null;
        if(!addedCartItem) return;

        tiktokAddToCartPopup(addedCartItem);
        facebookAddToCartPopup(addedCartItem, response?.data?.relatedData?.cartData?.facebookAddToCartGuid ?? '')
    }, [dispatch]);

    useEffect(() => {
        (async () => {
            await addProductHandler(productId);
        })();
    }, [productId, addProductHandler]);

    const close = () => {
        setIsOpened(false);
    };

    return (
        <>
            {
                isOpened &&
                <Popup
                    width="750px"
                    close={ close }
                    classes="add-to-cart-popup max-w-full max-h-full"
                    styles={{
                        paddingLeft: 0,
                        paddingRight: 0,
                    }}>

                    {
                        loading &&
                        <div className="w-full h-full flex items-center justify-center max-w-full max-h-full" style={{
                            width: '650px',
                            height: '600px',
                        }}>
                            <Preloader width="45px" height="25px" color="#4f4f4f" />
                        </div>
                    }

                    {
                        !loading && cartData &&
                        <>
                            <TopPanel />

                            <div className="py-5 px-4 md:px-6">
                                <AddedCartItem />
                                <YouMayAlsoLike addProductHandler={ addProductHandler }/>
                            </div>
                        </>
                    }
                </Popup>
            }
        </>
    )
};

export default AddToCartPopup;